import React, { useState, useEffect } from 'react';
import styles from './ChangePasswordModal.module.css';
import api from '../../../../../api.js';

const ChangePasswordModal = ({setAuthModalPage, marginTop}) => {
	const [oldPassword, setOldPassword] = useState('');
	const [newPassword, setNewPassword] = useState('');
	const [isPasswordLengthValid, setIsPasswordLengthValid] = useState(false);
	const [isPasswordCharValid, setIsPasswordCharValid] = useState(false);
	const [isWrongOldPW, setIsWrongOldPW] = useState(false);
	const [isAPIFinish, setIsAPIFinish] = useState(true);

	const handleChangePasswordClick = async () => {
		if (!isFormValid || isWrongOldPW || !isAPIFinish) return;
		
		setIsAPIFinish(false);
		try {
			const response = await api.post('/user/change_pw', {
			  old_user_pw: oldPassword,
			  new_user_pw: newPassword
			});
			alert('비밀번호 변경 완료!');
			setAuthModalPage(0);
		} catch (error) {
			if (error.response && error.response.status === 401)
				setIsWrongOldPW(true);
			else
				console.error('There was an error registering the user!', error);
		} finally{
			setIsAPIFinish(true);
		}
	};

	// Validate ID length and character
	useEffect(() => {
		setIsWrongOldPW(false);
	}, [oldPassword]);

	// Validate Password length and character
	useEffect(() => {
		setIsPasswordLengthValid(newPassword.length >= 8 && newPassword.length <= 20);
		setIsPasswordCharValid(/^(?=.*[a-zA-Z])(?=.*\d)(?!.*[ㄱ-ㅎㅏ-ㅣ가-힣])[a-zA-Z\d!@#$%^&*(),.?":{}|<>]+$/.test(newPassword));
	}, [newPassword]);

	useEffect(() => {
		const oldPasswordInput = document.getElementById('oldPasswordInput');
		oldPasswordInput.focus();
	}, []);

	const isFormValid = oldPassword.length>0 && isPasswordLengthValid && isPasswordCharValid;

	return (
		<div className={styles.headerParent} style={{maxHeight: `calc(100dvh - ${marginTop + 24}px)`, marginTop: `${marginTop}px`}}>
			<div className={styles.header}>
				<div className={styles.idpwParent}>

					{isWrongOldPW ? <b className={styles.idpw_duplicated}>현재 사용 중인 PW가 틀렸어요..!</b> : <b className={styles.idpw}>기존 PW와 새로운 PW를 입력!</b>}
					<div className={styles.frameParent}>
						<div className={styles.idParent}>
							<div className={styles.id}>기존 PW</div>
							<input
								type="password"
								className={styles.idinput}
								id="oldPasswordInput"
								placeholder="현재 비밀번호"
								value={oldPassword}
								onChange={(e) => setOldPassword(e.target.value)}
								onKeyDown={(e) => {if(e.key === 'Enter'){document.getElementById('newPasswordInput')?.focus();}}}
							/>
							<div className={styles.buttondefault}>
								<div className={styles.text}>
									<ul className={styles.ul}/>
								</div>
							</div>
						</div>
						<div className={styles.pwParent}>
							<div className={styles.id}>신규 PW</div>
							<input
								type="password"
								id="newPasswordInput"
								className={styles.idinput}
								placeholder="새로운 비밀번호"
								value={newPassword}
								onChange={(e) => setNewPassword(e.target.value)}
								onKeyDown={(e) => {if(e.key === 'Enter'){handleChangePasswordClick()}}}
							/>
							<div className={styles.buttondefault}>
								<div className={styles.text}>
									<ul className={styles.ul}>
										<li className={isPasswordLengthValid  ? styles.li : styles.li_invalid}>
											8~20자
										</li>
										<li className={isPasswordCharValid  ? styles.li : styles.li_invalid}>
											영문/숫자
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className={styles.buttondefaultWrapper}>
					<div
						className={`${styles.buttondefault1} ${isFormValid && !isWrongOldPW ? '' : styles.buttondefault1_invalid}`}
						disabled={!isFormValid}
						onClick={handleChangePasswordClick}
					>
						<div className={`${styles.text1} ${isFormValid && !isWrongOldPW ? '' : styles.text1_invalid}`}>비밀번호 변경</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ChangePasswordModal;
